import { Page } from '~/models/PaginatedItems'
import { NotificationRepository } from './repository'
import { Notification, NOTIFICATION_STATUS } from '~/models/Notification'

export class NotificationService {
	static async getUserNotifications(
		userId: string,
		page?: number,
		page_size?: number
	): Promise<Page<Notification>> {
		return await NotificationRepository.getUserNotifications(userId, page, page_size)
	}

	static async countUnread(userId: string): Promise<number> {
		return await NotificationRepository.countBy(userId, NOTIFICATION_STATUS.UNREAD)
	}

	static async markAsRead(notificationId: string): Promise<Notification> {
		return await NotificationRepository.markAsRead(notificationId)
	}

	static async markAllAsRead(): Promise<void> {
		return await NotificationRepository.markAllAsRead()
	}
}
